import { BasicDemographyClassification } from 'model/DemographyClassification';

type MinValue = number;
type MaxValue = number;
export type AggregationRange = [MinValue, MaxValue];

export const STORE_NAME = 'filtering';

export namespace FilteringState {
  export type Domain = {
    aggregationPeriod: AggregationRange;
    selectedClassifications: BasicDemographyClassification[];
  };

  export const INITIAL_AGGREGATION_PERIOD_DOMAIN: AggregationRange = [-6, 0];
  export const INITIAL_DOMAIN: Domain = {
    aggregationPeriod: INITIAL_AGGREGATION_PERIOD_DOMAIN,
    selectedClassifications: [],
  };
}

export type FilteringState = {
  filtering: FilteringState.Domain;
};
